export const getBox = (top, bottom, left, right, wallWidth) => {
    const box = {
        bottom: bottom,
        left: left,
        right: right,
        top: top,
        wallWidth: wallWidth
    };
    return {
        box: box,
        walls: [
            {
                id: "top",
                x1: box.left - box.wallWidth,
                y1: box.top - box.wallWidth / 2,
                x2: box.right + box.wallWidth,
                y2: box.top - box.wallWidth / 2,
                width: box.wallWidth
            },
            {
                id: "bottom",
                x1: box.left - box.wallWidth,
                y1: box.bottom + box.wallWidth / 2,
                x2: box.right + box.wallWidth,
                y2: box.bottom + box.wallWidth / 2,
                width: box.wallWidth
            },
            {
                id: "left",
                x1: box.left - box.wallWidth / 2,
                y1: box.top - box.wallWidth,
                x2: box.left - box.wallWidth / 2,
                y2: box.bottom + box.wallWidth,
                width: box.wallWidth
            },
            {
                id: "right",
                x1: box.right + box.wallWidth / 2,
                y1: box.top - box.wallWidth,
                x2: box.right + box.wallWidth / 2,
                y2: box.bottom + box.wallWidth,
                width: box.wallWidth
            }
        ]
    };
}